export default "__VITE_ASSET__2QOZIA4u__"